'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);

var GlobalStyles = styled.createGlobalStyle(["", " .", "{overflow:hidden;touch-action:none;overscroll-behavior:none;", "}"], function (props) {
  return !props.isOverscrollBehaviorSupported && props.elementIsDocumentBody && "\n    html {\n      @supports(height: constant(safe-area-inset-bottom))\n        --safe-area-inset-bottom: constant(safe-area-inset-bottom, 0);\n        height: calc(100vh - var(--safe-area-inset-bottom));\n      }\n\n      @supports(height: env(safe-area-inset-bottom))\n          --safe-area-inset-bottom: env(safe-area-inset-bottom, 0);\n          height: calc(100vh - var(--safe-area-inset-bottom));\n      }\n    }\n  ";
}, function (props) {
  return props["class"];
}, function (props) {
  var _props$top, _props$left;
  return !props.isOverscrollBehaviorSupported && "\n      position: fixed;\n      top: ".concat(((_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 0) * -1, "px;\n      bottom: 0;\n      right: 0;\n      left: ").concat(((_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 0) * -1, "px;\n    ");
});

exports.GlobalStyles = GlobalStyles;
